import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useGlobalContext } from '../context/GlobalState';
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";

/**
 * @category Pages
 * @returns {JSX.Element} <ProtectedRoute />
 * @description A protected route that checks if user has the correct role to access the route.
 */
export default function ProtectedRoute({ roles }) {
    const { user } = useGlobalContext();
    let decodedRole;
    try{
        decodedRole = jwtDecode(Cookies.get('accessToken'))?.role;
    } catch(e) {
        console.error("The jwt token is not available for decode: " + e);
    }

    // Check if user has the correct role to access the route
    const hasAccess = user?.role && roles.includes(user.role.toLowerCase()) || decodedRole && roles.includes(decodedRole);
    // If user has access, render the given route, else redirect to the home page
    return hasAccess ? <Outlet /> : <Navigate to="/" />;
}